export default __webpack_public_path__ + "static/adventurer-calendar-526fb51fb59ac796c3cc9d04d84751f3.png";